export default "__VITE_ASSET__DngzT6Z6__"